import assertOneOfStatus from "./assertOneOfStatus.js";
export function assertStatus(response, expectedStatus) {
    assertOneOfStatus(response, [expectedStatus]);
}
export default assertStatus;
